import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Signal the prerender build (vite.config.ts renderAfterDocumentEvent) that
// react-helmet has written this route's real title/meta/canonical, so the
// snapshot isn't taken before per-page tags land in <head>.
const helmetObserver = new MutationObserver(() => {
  if (document.head.querySelector('[data-react-helmet="true"]')) {
    document.dispatchEvent(new Event("render-event"));
    helmetObserver.disconnect();
  }
});
helmetObserver.observe(document.head, { childList: true, subtree: true });

// Sentry is not needed for first paint — defer it so the ~31KB chunk never
// blocks FCP/LCP. Loaded once the browser is idle after initial render.
const initSentry = () => {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: "https://553117542d615e1d4347b5369bd122de@o4511312260956160.ingest.us.sentry.io/4511312262922240",
      sendDefaultPii: true,
    });
  });
};

if (typeof window !== "undefined") {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(initSentry);
  } else {
    setTimeout(initSentry, 2000);
  }
}
